var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvironment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#B62020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16658 22.1868H19.8333C20.0543 22.1868 20.2662 22.099 20.4225 21.9427C20.5788 21.7864 20.6666 21.5745 20.6666 21.3535V14.3535C20.6666 14.0773 20.8904 13.8535 21.1666 13.8535H21.8733C22.3303 13.8535 22.5478 13.2909 22.2096 12.9835L14.5608 6.03014C14.4073 5.89053 14.2073 5.81317 13.9999 5.81317C13.7925 5.81317 13.5925 5.89053 13.4391 6.03014L5.79024 12.9835C5.45207 13.2909 5.66956 13.8535 6.12657 13.8535H6.83325C7.10939 13.8535 7.33325 14.0773 7.33325 14.3535V21.3535C7.33325 21.5745 7.42105 21.7864 7.57733 21.9427C7.73361 22.099 7.94557 22.1868 8.16658 22.1868ZM18.8362 12.1688C18.9405 12.2636 18.9999 12.398 18.9999 12.5388V20.0201C18.9999 20.2963 18.7761 20.5201 18.4999 20.5201L16.4999 20.5202V14.6868H11.4999V20.5201L9.49992 20.5201C9.22378 20.5201 8.99992 20.2963 8.99992 20.0201V12.5388C8.99992 12.398 9.05935 12.2636 9.1636 12.1688L13.6636 8.07835C13.8543 7.905 14.1455 7.905 14.3362 8.07835L18.8362 12.1688ZM13.1666 16.3535V20.5202H14.8333V16.3535H13.1666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironment);
export default __webpack_public_path__ + "static/media/Environment.9e1e15a7b121794458970924a0a66255.svg";
export { ForwardRef as ReactComponent };